import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExceptionStatus } from '../../services/http/exceptions/exceptions.interface';

@Component({
  selector: 'app-status-tag',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './status-tag.component.html',
  styleUrl: './status-tag.component.scss'
})
export class StatusTagComponent {
  @Input() status: string = ExceptionStatus.pending;
  @Input() simple: boolean = false;
  @Input() fontSize: string | null = null;
  exceptionStatus = ExceptionStatus;
}
